import { ObjectSchema } from "@hapi/joi";

import Joi, {
  getNumericErrors,
  getAttachmentsSchema,
} from "fe-shared/src/helpers/validation";
import {
  ErrorMessages,
  FileInterface,
  FileStatus,
} from "fe-shared/src/types/common";

import { CorrectionMaterial, Transfer } from "../../../types";

export const MAX_TIRES_COUNT = 99999;
export const MAX_SINGLE_WEIGHT = 999999999999;

export interface TransferFormContent {
  materials: CorrectionMaterial[];
  attachments: FileInterface[];
}

export const getInitialContent = ({
  materials,
  attachments,
}: Transfer): TransferFormContent => ({
  materials: materials.map(({ units, materialCode }) => ({
    units,
    materialCode,
  })),
  attachments: (attachments || []).map((f) => ({
    ...f,
    path: f.documentPath,
    id: f.documentPath,
    status: FileStatus.Loaded,
  })),
});

export const errorMessages: ErrorMessages = {
  materials: {
    "array.min": "validation.materialsRequired",
  },
  unitQuantity: {
    ...getNumericErrors(
      "validation.quantityRequired",
      "validation.quantityInvalid"
    ),
  },
};

export const getValidationConfig = (
  isDocumentRequired: boolean,
  isWithWeight: boolean,
  isWriteOff: boolean
): ObjectSchema<TransferFormContent> =>
  Joi.object({
    materials: Joi.array()
      .items(
        Joi.object({
          materialCode: Joi.string(),
          units: Joi.object({
            unit: Joi.any(),
            unitQuantity: isWriteOff
              ? Joi.number().required()
              : Joi.number()
                  .integer()
                  .min(1)
                  .max(isWithWeight ? MAX_SINGLE_WEIGHT : MAX_TIRES_COUNT)
                  .required(),
          }),
        }).unknown()
      )
      .min(1),
    attachments: getAttachmentsSchema("attachments").min(
      isDocumentRequired ? 1 : 0
    ),
  });
